import { TouringSchedule } from '@features';
import { Box } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '../_layout';

export const Dashboard: React.FC = () => {
  const { t } = useTranslation('dashboard');

  return (
    <PageLayout title={t('TITLE')}>
      <Box py="md">
        <TouringSchedule />
      </Box>
    </PageLayout>
  );
};
